import { shortDateString } from '@mnd-frontend/dates';

/*
    Chrome renders the date as "mars" instead of "mar." using Intl.DateTimeFormat with month: 'short'
    which causes rehydration issues. This is a workaround to fix the issue.
  */
const fixMarch = (date: string) => date.replace('mars', 'mar.');

export const timeSpanString = ({
  fromDate,
  toDate,
  timezone,
  locale,
}: {
  fromDate: Date;
  toDate: Date;
  timezone: string;
  locale: string;
}) => {
  if (fromDate === toDate) return fixMarch(shortDateString(fromDate, timezone, locale));
  return `${fixMarch(shortDateString(fromDate, timezone, locale))} - ${fixMarch(
    shortDateString(toDate, timezone, locale),
  )}`;
};

export const TimeSpan = ({
  fromDate,
  toDate,
  timezone,
  locale,
}: {
  fromDate: Date;
  toDate: Date;
  timezone: string;
  locale: string;
}) => {
  if (fromDate === toDate)
    return (
      <time dateTime={fromDate.toISOString()}>
        {fixMarch(shortDateString(fromDate, timezone, locale))}
      </time>
    );
  return (
    <>
      <time dateTime={fromDate.toISOString()}>
        {fixMarch(shortDateString(fromDate ?? '', timezone, locale))}
      </time>{' '}
      -{' '}
      <time dateTime={toDate.toISOString()}>
        {fixMarch(shortDateString(toDate, timezone, locale))}
      </time>
    </>
  );
};
